exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ItemCoordinateControl[data-v-753b7568] {\n  display: grid;\n  grid-template-columns: 20px 1fr;\n}\n.ItemCoordinateControl_Label[data-v-753b7568] {\n    text-align: center;\n}\n.ItemCoordinateControl_Input[data-v-753b7568] {\n    height: 14px;\n}\n", ""]);

// exports
